module.exports = __webpack_public_path__ + "f0dc2252add0773414f2dc45dca7eb6e.png";